import { ymPushParams } from "../../../../../../../utils/ym.alternative";
import { withBlockPayment } from "../../../../../../../utils/ym.helpers";
import { EAnalyticsActionType } from "./constants";
export var onPhoneInputAnalyticsHandler = function onPhoneInputAnalyticsHandler() {
  ymPushParams(withBlockPayment({
    sberpay: {
      phone_number: EAnalyticsActionType.FillIn
    }
  }));
};
export var onButtonPressAnalyticsHandler = function onButtonPressAnalyticsHandler() {
  ymPushParams(withBlockPayment({
    sberpay: {
      button_push: 'click'
    }
  }));
};